export const tomadorFilterConfig = [
  {
    id: 'Nome',
    type: 'text',
    label: 'Nome',
    placeholder: 'Digite o nome do tomador'
  },
  {
    id: 'CNPJ',
    type: 'masked',
    label: 'CNPJ',
    placeholder: 'Digite o CNPJ',
    mask: [
      /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/
    ]
  }
];
